import React, { useState, useEffect } from 'react';

export default function CookieConsentPopup({ affiliateUrl, cookiesMessage }) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 768
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const currentStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: isMobile ? "flex-start" : "center",
      justifyContent: "center",
      zIndex: 9999,
      paddingTop: isMobile ? "10vh" : "0",
    },
    popup: {
      background: "#fff",
      padding: "32px 24px",
      borderRadius: "12px",
      boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
      maxWidth: "90vw",
      width: isMobile ? "auto" : "400px",
      minWidth: "280px", // Ensure minimum width on very small screens
      textAlign: "center",
      marginTop: isMobile ? "0" : "0", // marginTop is on overlay via paddingTop now
    },
    text: {
      fontSize: "1.1rem",
      marginBottom: "24px",
      color: "#222",
    },
    button: {
      background: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      padding: "12px 32px",
      fontSize: "1rem",
      cursor: "pointer",
      transition: "background 0.2s",
      textDecoration: 'none',
    },
  };

  return (
    <div style={currentStyles.overlay}>
      <div style={currentStyles.popup}>
        <p style={currentStyles.text}>{cookiesMessage}</p>
        <a
          href={affiliateUrl} // Kept for context/fallback, but click is handled
          style={currentStyles.button}
          onClick={(e) => {
            e.preventDefault(); // Prevent default link navigation
            if (typeof window.gtag_report_conversion === 'function') {
              window.gtag_report_conversion(affiliateUrl);
            } else {
              // Fallback if the function isn't found, though it should be
              console.warn('gtag_report_conversion function not found. Redirecting directly.');
              window.location.href = affiliateUrl;
            }
            return false; // Extra measure to prevent default behavior
          }}
        >
          Aceitar
        </a>
      </div>
    </div>
  );
}

// Styles are now defined dynamically within the CookieConsentPopup component.
